import { get,post } from "@/util/httpCloud3DEH.js";
import globalVar from "@/util/globalVar";

//动态分页


//推荐政策 分页
export function list(params) {
  // params.lang = globalVar.ApiLang;
  return get("/api/exhibition/getList?lang=zh", params,);
}

// //最新
// export function getIndexData(params) {
//   // params.lang = globalVar.ApiLang;
//   return get("/client/applet/getIndexData", params);
// }


// WEBPACK FOOTER //
// ./src/view/exhibitionHall/api.js